import axios from 'axios';
import {SessionsApi} from '../../services/Apis';
import api from '../../services/Apis/api';
import apiUpload from '../../services/Apis/apiUpload';
import FuseUtils from '../auth/FuseUtils';

class jwtService extends FuseUtils.EventEmitter {

    init()
    {
        this.setInterceptors();
        this.handleAuthentication();
    }

    setInterceptors = () => {
        axios.interceptors.response.use(response => {
            return response;
        }, err => {
            return new Promise((resolve, reject) => {
                if ( err.response.status === 401 && err.config && !err.config.__isRetryRequest )
                {
                    // if you ever get an unauthorized response, logout the user
                    this.emit('onAutoLogout', 'Invalid access_token');
                    this.setSession(null);
                }
                throw err;
            });
        });
    };

    handleAuthentication = () => {

        let access_token = this.getAccessToken();

        if ( !access_token )
        {
            this.emit('onNoAccessToken');

            return;
        }

        if ( this.isAuthTokenValid(access_token) )
        {
            this.setSession(access_token);
            this.emit('onAutoLogin', true);
        }
        else
        {
            this.setSession(null);
            this.emit('onAutoLogout', 'access_token expired');
        }
    };

    createUser = (data) => {
        return new Promise((resolve, reject) => {
            axios.post('/api/auth/register', data)
                .then(response => {
                    if ( response.data.user )
                    {
                        this.setSession(response.data.access_token);
                        resolve(response.data.user);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                });
        });
    };

    signInWithEmailAndPassword = (email, password,brand) => {        
        return new Promise((resolve, reject) => {
            const data = {
                login: email,
                password,
                brand,
                persistent: false,
                type: 'DEFAULT'
            }            
            SessionsApi.create(data)
            .then(response => {
                this.setSession(response.data.accessToken);
                this.setSessionId(response.data.sessionId);
                this.setLoggedUser(response.data);
                resolve(response.data);
            })
            .catch(error => {
                if (error && error.response && error.response.status && error.response.status === 502) {
                    reject({message: '502 Bad Gateway'})
                } else if (error && error.response && error.response.data && error.response.data.message) {
                    reject({message: error.response.data.message})
                }
            })
        });        
    };

    getPermissionsByUser= (userId) => {
        return new Promise((resolve, reject) => {
           
            const access_token = this.getAccessToken();
            api.defaults.headers.common['Authorization'] = access_token;
           
                SessionsApi.getPermissionsByUser(userId, {data:{}})
                .then(response => {
                    if ( response.data)
                    {
                        resolve(response.data);
                    }
                   
                })
                .catch(error => {
                    reject('Failed to get permissions.');
                });
           // }
        });
    };

    signInWithToken = () => {
        return new Promise((resolve, reject) => {
            /*axios.get('/api/auth/access-token', {
                data: {
                    access_token: this.getAccessToken()
                }
            })*/
            const access_token = this.getAccessToken();
            api.defaults.headers.common['Authorization'] = access_token;
            apiUpload.defaults.headers.common['Authorization'] = access_token;
            const sid = this.getSessionId();
            if (!sid || !access_token) {
                this.logout();
                reject('Failed to login with token.');
            } else {
                
                SessionsApi.getById(sid, {data:{}})
                .then(response => {
                    if ( response.data.user )
                    {                        
                        resolve(response.data);
                    }
                    else
                    {
                        this.logout();
                        reject('Failed to login with token.');
                    }
                })
                .catch(error => {
                    this.logout();
                    reject('Failed to login with token.');
                });
            }
        });
    };

   
    setLoggedUser = loggedUser => {
        if (loggedUser) {
            sessionStorage.setItem('loggedUser', JSON.stringify(loggedUser));
        } else {
            sessionStorage.removeItem('loggedUser');
        }
    }

    setSession = access_token => {
        if ( access_token )
        {
            sessionStorage.setItem('access_token', access_token);
            api.defaults.headers.common['Authorization'] = access_token;
            apiUpload.defaults.headers.common['Authorization'] = access_token;
        }
        else
        {
            sessionStorage.removeItem('access_token');
            delete api.defaults.headers.common['Authorization'];
        }
    };

    setSessionId = (sessionId) => {
        if (sessionId) {
            sessionStorage.setItem('access_sid', sessionId);
            sessionStorage.setItem('sid', sessionId);
        } else {
            sessionStorage.removeItem('sid');
            sessionStorage.removeItem('access_sid');
        }
    }

   

    isAuthTokenValid = access_token => {
        if ( !access_token )
        {
            return false;
        }

        const currentTime = Date.now() / 1000;
        if ( currentTime )
        {
            console.warn('access token expired');
            return false;
        }
        else
        {
            return true;
        }
    };

    getAccessToken = () => {
        return window.sessionStorage.getItem('access_token');
    };

    getSessionId = () => {
        return window.sessionStorage.getItem('sid');
    }
}

const instance = new jwtService();

export default instance;
